import factory from './icon';
import Svg8x8 from './Glyphs/Check_8x8.svg';
import Svg12x12 from './Glyphs/Check_12x12.svg';
import Svg16x16 from './Glyphs/Check_16x16.svg';

export const Check8x8 = factory(Svg8x8, 8, 8);
export const Check12x12 = factory(Svg12x12, 12, 12);
export const Check16x16 = factory(Svg16x16, 16, 16);
